import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetRuleResponse } from '@hud/rules-dtos/api-rules.dtos';

export const RULE_ID = 'rule';

export default function useRule(ruleId?: string) {
  const { client, isReady } = useClient('detection');
  return useQuery({
    queryKey: [RULE_ID, ruleId],
    queryFn: async () => {
      const response = await client.get<GetRuleResponse>(`/rules/${ruleId}`);
      return GetRuleResponse.parse(response.data);
    },
    enabled: isReady && !!ruleId,
  });
}
